import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';

import { IconLibrary } from '@finnairoyj/fcom-ui-styles';

import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

import type { IconName } from '../icons/icons.interfaces';
import { ChipTheme } from './interfaces';
import { IconComponent } from '../icons/icon/icon.component';

@Component({
  selector: 'fcom-chip',
  styleUrls: ['chip.component.scss'],
  templateUrl: 'chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class ChipComponent {
  private themeService = inject(FinnairThemeService);
  protected readonly ChipTheme = ChipTheme;
  protected readonly FinnairTheme = FinnairTheme;
  protected readonly SiteTheme = this.themeService.siteTheme();

  text = input<string>();
  title = input<string>();
  iconName = input<IconName>();
  iconCategory = input(IconLibrary.SVG_LIBRARY);
  theme = input(ChipTheme.DEFAULT);
  disabled = input(false);

  tagClicked = output<Event>();
  blur = output<Event>();

  computedTheme = computed((): ChipTheme => {
    if (this.SiteTheme === FinnairTheme.LEGACY) {
      return this.theme();
    }

    switch (this.theme()) {
      case ChipTheme.POPULAR:
      case ChipTheme.ACTIVE:
        return ChipTheme.ACTIVE;
      default:
        return ChipTheme.DEFAULT;
    }
  });
}
